<mat-form-field class="example-full-width" subscriptSizing="dynamic">
	<mat-label>{{ label }}</mat-label>
	<textarea
		matInput
		class="resize nice-scroll visible-scroll colored-scroll-track"
		rows="2"
		[formControl]="formControl"
		(focusout)="emitValue()"
		(keydown.enter)="emitValue()"
		cdkAutosizeMaxRows="12"
		cdkAutosizeMinRows="2"
		cdkTextareaAutosize
	></textarea>
	<mat-error>
		@if (formControl.errors?.whitespace) {
			<span> Spaces only is restricted </span>
		}
	</mat-error>
</mat-form-field>
